import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function fetchQuoteGroups(spaceId: string) {
  const { data, error } = await apiClient
    .from('quote_comparison_groups')
    .select('id, name, created_at, quotes(count)')
    .eq('space_id', spaceId)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return data.map((group) => ({
    id: group.id,
    name: group.name,
    quoteCount: group.quotes[0]?.count ?? 0,
  }));
}

export type QuoteGroupSummary = Awaited<ReturnType<typeof fetchQuoteGroups>>[number];

export function useGetQuoteGroups() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.groupsList(currentSpace?.id ?? ''),
    queryFn: () => fetchQuoteGroups(currentSpace!.id),
    enabled: !!currentSpace?.id,
  });
}
